import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import EmptyPageView from '@/views/common/EmptyPageView'
// import HomePageView from '@/views/HomePage'
import db from 'utils/localstorage'
import request from 'utils/request'

import print from '@/views/business/tagprint/TagPrint'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let constRouter = [
  {
    path: '/login',
    name: '登录页',
    component: LoginView
  },
  {
    path: '/index',
    name: '首页',
    redirect: '/map'
  },
  {
    path: '/print',           //输入链接无租户名的跳转此组件
    name: 'print',
    component: print
  }
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login']

let asyncRouter


// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    db.clear()
    next()
  } else {
    let token = db.get('USER_TOKEN')
    let user = db.get('USER')
    let userRouter = get('USER_ROUTER')
    if (token.length && user) { // 有token 且 有用户信息，则进行获取路由信息
      if (!asyncRouter) { // 异步路由是否为空
        if (!userRouter) { // 用户路由是否为空
          // 发送请求获取用户的路由菜单
          request.get(`menu/${user.userName}`).then((res) => {
            asyncRouter = res.data
            save('USER_ROUTER', asyncRouter)
            go(to, next)
          })
        } else {
          asyncRouter = userRouter // 同步，再跳转
          go(to, next)
        }
      } else {
        next()
      }
    } else {
      // 没有token没有用户信息直接跳转去login页面
      next('login')
    }
  }
})

/**
 * 封装了放行的处理，实际上里头做了asyncRouter的component（字符串）替换真实component实例，
 * 然后将替换后的asyncRouter,加到常量定义的基础router中，生成登录验证后的权限路由表
 * @param {*} to
 * @param {*} next
 */
function go(to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({ ...to, replace: true })
}

/**
 * localStorage设置key-value的方法封装，将json对象的data转为字符串value保存
 * @param {*} name
 * @param {*} data
 */
function save(name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}
/**
 * localStorage根据key，获取value的方法封装，将字符串转为json对象，并返回
 * @param {*} name
 */
function get(name) {
  return JSON.parse(localStorage.getItem(name))
}
/**
 * routes（json对象）的component的属性值（字符串）替换为真正vue界面实例
 * @param {*} routes
 */
function filterAsyncRouter(routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        // case 'HomePageView':
        //   route.component = HomePageView
        //   break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}
/**
 * 匹配指定路径下是否存在组件的vue文件，如果是存在的则导入并返回组件实例
 * 注意：
 * 对于项目中新建vue文件，如需要动态导入的界面，
 * 必须重启当前vue项目，动态import才会生效，否则会提示找不到这个vue文件
 * @param {*} path
 */
function view(path) {
  return function (resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js